import { isReactNativeIos } from '@mobi/web-native-comms/web'

export function getBiometricsToggleText(biometricsType?: string): string {
  switch (biometricsType) {
    case 'FACIAL_RECOGNITION':
      return isReactNativeIos ? 'Enable Face ID' : 'Enable Face Recognition'
    case 'FINGERPRINT':
      return isReactNativeIos ? 'Enable Touch ID' : 'Enable Fingerprint Login'
    case 'IRIS':
      return 'Enable Iris Login'
    default:
      return 'Enable PIN / Biometrics'
  }
}
